import styled, { keyframes } from 'styled-components'

const Click = keyframes`
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.02);
  }
`
interface ContainerProps {
  backgroundcolor: string
  padding?: string
  border?: string
  hovercolor?: string
}

export const Container = styled.button<ContainerProps>`
  height: 100%;
  width: 100%;
  background-color: ${(props) => props.backgroundcolor};
  border: ${(props) => (props.border ? props.border : 'none')};
  border-radius: 0.25rem;
  cursor: pointer;
  padding: ${(props) => (props.padding ? props.padding : '0.4rem')};
  display: flex;
  align-items: center;
  overflow: hidden;

  &:hover {
    background-color: ${(props) => (props.hovercolor ? props.hovercolor : '')};
  }

  &:active {
    animation: ${Click} 0.3s forwards;
  }

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-decoration: none;
    color: red;
  }
`
